export const ADD_STORAGE = "ADD_STORAGE";
export const REMOVE_STORAGE = "REMOVE_STORAGE";
export const SET_DEPOSITS = "SET_DEPOSITS";
export const FETCH_DEPOSITS_FAILED = "FETCH_DEPOSITS_FAILED";
export const FETCH_DEPOSITS_STARTING = "FETCH_DEPOSITS_STARTING";

export const SET_REVENUE = "SET_REVENUE";
export const FETCH_REVENUE_FAILED = "FETCH_REVENUE_FAILED";
export const FETCH_REVENUE_STARTING = "FETCH_REVENUE_STARTING";

export const SET_REVENUE_PERFORMANCE = "SET_REVENUE_PERFORMANCE";
export const FETCH_REVENUE_PERFORMANCE_STARTING =
  "FETCH_REVENUE_PERFORMANCE_STARTING";
export const FETCH_REVENUE_PERFORMANCE_FAILED =
  "FETCH_REVENUE_PERFORMANCE_FAILED";

export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_INFO_UPDATE_TOKEN = "SET_USER_INFO_UPDATE_TOKEN";
export const REMOVE_USER_INFO = "REMOVE_USER_INFO";
export const SET_LANG = "SET_LANG";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";

export const SET_COMMISSION = "SET_COMMISSION";
export const FETCH_COMMISSION_STARTING = "FETCH_COMMISSION_STARTING";
export const FETCH_COMMISSION_FAILED = "FETCH_COMMISSION_FAILED";

export const SET_COMMISSION_PLAN = "SET_COMMISSION_PLAN";
export const FETCH_COMMISSION_PLAN_STARTING = "FETCH_COMMISSION_PLAN_STARTING";
export const FETCH_COMMISSION_PLAN_FAILED = "FETCH_COMMISSION_PLAN_FAILED";

export const SET_COMMISSION_PERFORMANCE = "SET_COMMISSION_PERFORMANCE";
export const FETCH_COMMISSION_PERFORMANCE_STARTING =
  "FETCH_COMMISSION_PERFORMANCE_STARTING";
export const FETCH_COMMISSION_PERFORMANCE_FAILED =
  "FETCH_COMMISSION_PERFORMANCE_FAILED";

export const SET_COUPONS = "SET_COUPONS";
export const FETCH_COUPONS_STARTING = "FETCH_COUPONS_STARTING";
export const FETCH_COUPONS_FAILED = "FETCH_COUPONS_FAILED";

export const SET_CITY = "SET_CITY";
export const FETCH_CITY_STARTING = "FETCH_CITY_STARTING";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const SET_STORAGES = "SET_STORAGES";
export const FETCH_STORAGES_STARTING = "FETCH_STORAGES_STARTING";
export const FETCH_STORAGES_FAILED = "FETCH_STORAGES_FAILED";

export const SET_USER = "SET_USER";
export const FETCH_USER_STARTING = "FETCH_USER_STARTING";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";

export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";

export const FETCH_ORGANIZATION_STARTING = "FETCH_ORGANIZATION_STARTING";
export const FETCH_ORGANIZATION_FAILED = "FETCH_ORGANIZATION_FAILED";
export const CHANGING_ORGANIZATION_SUCCESSFULLY =
  "CHANGING_ORGANIZATION_SUCCESSFULLY";
export const SET_ORGANIZATION_DETAILS = "SET_ORGANIZATION_DETAILS";
export const SET_INVOICES_LEGACY = "SET_INVOICES_LEGACY";
export const SET_INVOICE_LEGACY = "SET_INVOICE_LEGACY";
export const SET_INVOICES = "SET_INVOICES";
export const SET_CREDIT_NOTES = "SET_CREDIT_NOTES";
export const SET_CREDIT_NOTE = "SET_CREDIT_NOTE";

export const SET_AFFILIATE_INFO = "SET_AFFILIATE_INFO";

export const SET_ORDERS_TODAY = "SET_ORDERS_TODAY";
export const SET_ORDERS_TOMORROW = "SET_ORDERS_TOMORROW";
export const FETCH_ORDERS_TODAY_FAILED = "FETCH_ORDERS_TODAY_FAILED";
export const FETCH_ORDERS_TOMORROW_FAILED = "FETCH_ORDERS_TOMORROW_FAILED";
export const FETCH_ORDERS_STARTING = "FETCH_ORDERS_STARTING";

export const FETCH_OPENINGHOURS = "FETCH_OPENINGHOURS";
export const SET_OPENINGHOURS = "SET_OPENINGHOURS";
export const FETCH_OPENINGHOURS_FAILED = "FETCH_OPENINGHOURS_FAILED";
export const UPDATE_OPENINGHOURS_STATUS = "UPDATE_OPENINGHOURS_STATUS";
